import { Fragment } from "@wordpress/element";

import {StyleOptions} from "~buildable/utils/enums";
import BlockColorOptions from "~buildable/utils/block-color-options";
import BlockBgOptions from "~buildable/utils/block-bg-options";
import BlockSizeOptions from "~buildable/utils/block-size-options";
import BlockNegativeMarginsOptions
  from "~buildable/utils/block-negative-margins-options";
import BlockRemovePaddingOptions
  from "~buildable/utils/block-remove-padding-options";

const StyleOptionsComponents = {
  [StyleOptions.BLOCK_COLOR]: BlockColorOptions,
  [StyleOptions.BLOCK_BG]: BlockBgOptions,
  [StyleOptions.BLOCK_SIZE]: BlockSizeOptions,
  [StyleOptions.BLOCK_NEGATIVE_MARGINS]: BlockNegativeMarginsOptions,
  [StyleOptions.BLOCK_REMOVE_PADDING]: BlockRemovePaddingOptions
};

const getBlockStyleOptions = (props, excludeOptions = null, config = null) => {
  let optionsArray = Object.values(StyleOptions);
  if (excludeOptions !== null) {
    if (Array.isArray(excludeOptions)) {
      optionsArray = optionsArray.filter((option) => excludeOptions.indexOf(option) === -1);
    } else {
      throw "'excludeOptions' passed to getBlockStyleOptions method must be an Array.";
    }
  }

  if (config !== null && config.constructor === Object) {
    if (config.bgMediaAllowsVideo) {
      props.attributes.bgMediaAllowsVideo = true;
    }
    if (config.bgMediaAllowsMultipleImages) {
      props.attributes.bgMediaAllowsMultipleImages = true;
    }
    if (config.noBgColor) {
      props.attributes.noBgColor = true;
    }
    if (config.noAccentColor) {
      props.attributes.noAccentColor = true;
    }
    if (config.allowTransparentBg) {
      props.attributes.allowTransparentBg = true;
    }
    if (config.append) {
      props.attributes.append = config.append;
    }
  }

  return (
    <Fragment>
      { (! config || !config.override) && optionsArray.map((option) => {
        if (option === StyleOptions.BLOCK_COLOR && (config && config.overrideColors)) {
          return config.overrideColors;
        }

        const StyleOptionComponent = StyleOptionsComponents[option];

        return (
          <StyleOptionComponent
            key={ `component_${option}` }
            blockAttributes={ props.attributes }
            setAttributes={ props.setAttributes }
          />
        )
      })}
      { (!!config && !!config.override) && config.override }
    </Fragment>
  )
}

export default getBlockStyleOptions;
